import React from 'react';
import _get from 'lodash/get';
import { getQuestionVisibility } from 'containers/Assessment/utils';
import SingleQuestion from 'components/Survey/SingleQuestion';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    '& > div h6': {
      fontSize: 'inherit',
    },
  },
});

export const CourseCustomQuestions = ({
  node,
  saveAnswer,
  answers,
  questionRenderers = {},
}) => {
  const classes = useStyles();

  if (!_get(node, 'data.target.fields.copy.customAssessmentQuestion.data')) {
    return null;
  }

  const customQuestions =
    node.data.target.fields.copy.customAssessmentQuestion.data;

  const updateAnswer = (name, value) => {
    const unAnswered = customQuestions.filter(
      question => !answers[question.name],
    );
    const isAllAnswered =
      unAnswered.length === 1 && unAnswered[0].name === name && !!value;
    saveAnswer({ name, value }, isAllAnswered);
  };

  const onCheckboxChange = (name, value) => {
    const current = answers[name] || [];
    const selected = current.includes(value)
      ? current.filter(v => v !== value)
      : [...current, value];
    updateAnswer(name, selected);
  };

  const surveyContextProps = {
    error: [],
    answers,
    onAnswerChange: updateAnswer,
    onCheckboxChange,
  };

  return (
    <div className={classes.root}>
      {customQuestions
        .filter(question => getQuestionVisibility(question, answers))
        .map((question, idx) =>
          questionRenderers[question.type] ? (
            questionRenderers[question.type]({
              question,
              answers,
              onAnswerChange: updateAnswer,
            })
          ) : (
            <SingleQuestion
              key={question.name}
              number={idx + 1}
              surveyContextProps={surveyContextProps}
              withinPanel
              {...question}
            />
          ),
        )}
    </div>
  );
};
